// extracted by mini-css-extract-plugin
export default {"faqCard":"FAQEntryComponent_faqCard__6T5An","skeletonQuestion":"FAQEntryComponent_skeletonQuestion__u3FsH","skeletonAnswer":"FAQEntryComponent_skeletonAnswer__oH4wK"};